// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"SearchBox-module--searchBox--1B8c-"};